export const apiInterface = {
    data() {
        return {

        }
    },
    methods: {
        async getApiResource(resource, accessToken){
            try {
                let getResource = await fetch(`https://api.spotify.com/v1${resource}`, {
                    headers: {
                    'Authorization': `Bearer ${accessToken}` 
                    }
                });
                if (getResource.status >= 400 && getResource.status < 600) {
                    throw new Error('fetch fockin sucky at error handling raaaaaa');
                }
                const resourceJson = await getResource.json();
                return resourceJson;
            } catch(error) {
                console.log(error);
            }
        },
    }
    
}